module.exports = __webpack_public_path__ + "img/choose-box.c6ab998a.png";